import React, { useState, useEffect } from 'react';
import { FileText, ChevronDown, ChevronUp } from 'lucide-react';
import { __ } from './translations';
import SearchInput from './components/SearchInput';

const KnowledgeBase = () => {
    const [articles, setArticles] = useState([]);
    const [filteredArticles, setFilteredArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedId, setExpandedId] = useState(null);

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const response = await fetch(
                    `${boardMemberData.restURL}board-member/v1/member-information/knowledge-base`,
                    {
                        headers: {
                            'X-WP-Nonce': boardMemberData.nonce
                        }
                    }
                );
                
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                setArticles(data);
                setFilteredArticles(data);
            } catch (err) {
                setError('Failed to load knowledge base articles');
                console.error('Error fetching articles:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchArticles();
    }, []);

    const toggleArticle = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };
    const handleSearch = (searchTerm) => {
        if (!searchTerm.trim()) {
          setFilteredArticles(articles);
          return;
        }
    
        const filtered = articles.filter((article) => {
          const searchString = `${article.title} ${article.content} ${article.categories.join(' ')}`.toLowerCase();
          return searchString.includes(searchTerm.toLowerCase());
        });
        setFilteredArticles(filtered);
    };
    
    if (loading) {
        return <div className="text-center py-6">{__('Loading...')}</div>;
    }

    if (error) {
        return <div className="text-red-500 py-6">{error}</div>;
    }

    if (!articles.length) {
        return <div className="text-center py-6">{__('No knowledge base articles available.')}</div>;
    }

    return (
        <>
        <div className="w-1/4 ml-auto">
                <SearchInput 
                    onSearch={handleSearch} 
                    placeholder={__('Search knowledge base...')}
                />
            </div>
        <div className="space-y-4">
 {filteredArticles.map((article) => (
                <div 
                    key={article.id} 
                    className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden"
                >
                    <button
                        onClick={() => toggleArticle(article.id)}
                        className="w-full px-6 py-4 flex items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors"
                    >
                        <h3 className="text-lg font-semibold text-left">{article.title}</h3>
                        {expandedId === article.id ? (
                            <ChevronUp className="w-5 h-5 text-gray-500" />
                        ) : (
                            <ChevronDown className="w-5 h-5 text-gray-500" />
                        )}
                    </button>

                    {expandedId === article.id && (
                        <div className="p-6">
                            <div 
                                className="prose max-w-none mb-4"
                                dangerouslySetInnerHTML={{ __html: article.content }}
                            />

                            {article.pdf_url && (
                                <div className="pt-4 border-t">
                                    <a
                                        href={article.pdf_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                                    >
                                        <FileText className="w-4 h-4 mr-2" />
                                        {__('Download PDF')}
                                    </a>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ))}
            </div>
            </>
    );
};

export default KnowledgeBase;